import React, { useEffect } from "react";
import useApiHouse from "../api/useApiHouse";
import { useSelector, useDispatch } from "react-redux";
import { fileReconJobPayload } from "../api/apiPayloads";
import { setLoader } from "../slices/loaderSlice";
import useGetFormData from "./useGetFormData";
import useStatusDetail from "./useStatusDetail";

const useFileReconJob = () => {
    const [fileReconJobApi, {data, isLoading, error}] = useApiHouse();
    const {getStatusDetail} = useStatusDetail();
    const {currentJob: {reconShipmentId}} = useSelector((state) => state.currentJob)
    const dispatch = useDispatch();
    const fileReconJob = (setFilingState) => {
        fileReconJobApi(fileReconJobPayload(reconShipmentId)).then(filedXY=>{
            setFilingState("FILED");
        });
        dispatch(setLoader({path:"formGlobalLoader", value:true}))
    }
    useEffect(() => {
        if(!isLoading && data){
            dispatch(setLoader({path:"formGlobalLoader", value:false}))
            getStatusDetail();
        }
    }, [isLoading, data, error])
    return { fileReconJob };
}
 
export default useFileReconJob;